import ResponsiveHelper from '../../../../assets/src/js/modules/responsiveHelper.js';
import slideAccordion from '../../../../assets/src/js/modules/accordionPlugin.js';

jQuery(function () {
    initAccordion();
});


// accordion menu init
function initAccordion () {
    ResponsiveHelper.addRange({
        '..1023': {
            on: function () {
                jQuery('.session__select-list').slideAccordion({
                    opener: '>a',
                    slider: '.slide',
                    animSpeed: 300,
                    allowClickWhenExpanded: true
                });
            },
            off: function () {
                jQuery('.session__select-list').slideAccordion('destroy');
            }
        }
    });
}